// extracted by mini-css-extract-plugin
module.exports = {"switch":"LargeSwitch_switch__1uktz","disabled":"LargeSwitch_disabled__3gtYQ"};